import { Box } from '@wix/design-system';
import { useAnonymous } from '@wix/package-picker-shared-studio';
import { Footer as LoggedInFooter } from '@wix/premium-purchase-platform/@components';
import React from 'react';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';
import { AnonymousFooterBanner } from './AnonymousFooterBanner';

export const PageFooter = () => {
  const { isAnonymous } = useAnonymous();

  return (
    <Box width="100%" direction="vertical">
      {isAnonymous ? (
        <AnonymousFooterBanner />
      ) : (
        <LoggedInFooter
          marginBottom="SP2"
          isLoggedIn={true}
          onLinkClick={(_, linkCode) => {
            StudioPackagePickerModule.internals.bi.onFooterLinkClick?.({
              linkCode,
            });
          }}
        />
      )}
    </Box>
  );
};
